"use client"

import React, { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { useAuth0 } from "@auth0/auth0-react"
import { getApiBaseUrl } from "../../config/apiBase"
import GenericRefinementWorkspace from "../refinement/GenericRefinementWorkspace"

export default function PolicyRefinementPage() {
  const { policyId } = useParams()
  const { getAccessTokenSilently } = useAuth0()
  const [policy, setPolicy] = useState(null)
  useEffect(() => {
    let active = true
    const load = async () => {
      const token = await getAccessTokenSilently({ authorizationParams: { audience: process.env.REACT_APP_API_AUDIENCE } })
      const response = await fetch(`${getApiBaseUrl()}/api/policies/${policyId}`, { headers: { Authorization: `Bearer ${token}` } })
      if (active && response.ok) setPolicy(await response.json())
    }
    load().catch(() => {})
    return () => { active = false }
  }, [policyId, getAccessTokenSilently])
  return <GenericRefinementWorkspace
    type="policy" itemId={policyId} itemLabel="Policy" item={policy} title={policy?.title || "this policy"}
    currentFields={[
      { label: "Current proposal", value: policy?.policyStatement },
      { label: "Effective date", value: policy?.effectiveDate ? new Date(policy.effectiveDate).toLocaleDateString() : "" },
    ]}
    fieldOptions={[
      { value: "PolicyStatement", label: "Policy wording" },
      { value: "Scope", label: "Who or what it applies to" },
      { value: "EffectiveDate", label: "Effective date" },
      { value: "Safeguards", label: "Safeguards or exceptions" },
      { value: "Accountability", label: "Responsibility and review" },
    ]}
  />
}
